module.exports = __webpack_public_path__ + "static/media/sugarBoxes.7280104d.jpg";